/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import Vue from 'vue';
// import { Message, MessageBox } from 'element-ui';
import _ from 'lodash';
import {
    GET_HISTORY_LIST_REQUEST,
    GET_HISTORY_LIST_SUCCESS,
    GET_HISTORY_LIST_FAILURE,
    UPDATE_HISTORY_LIST,
    UPDATE_HISTORY_LIST_PARAMS,
    RESET_HISTORY_LIST,
    RESOLVE_HISTORY_LIST_PARAMS,
} from '../mutationTypes';

const state = {
    importType: 1,
    loading: false,
    page: 1,
    pagesize: 20,
    name: '',
    mobile: '',
    carNo: '',
    importNo: '',
    startEndDate: [], // 组件返回形式为数组, 请求时分开提交
    listData: [],
    pageCount: 1,
    reqParams: {},
    exportHistoryUrl: '' // 导出链接
};

const mutations = {
    [GET_HISTORY_LIST_REQUEST](state) {
        state.loading = true;
    },
    [GET_HISTORY_LIST_SUCCESS](state, res) {
        state.loading = false;
        state.pageCount = res.page_count;
        state.listData = res.listData;
    },
    [UPDATE_HISTORY_LIST](state, res) {
        state.listData = res;
    },
    [GET_HISTORY_LIST_FAILURE](state) {
        state.loading = false;
        state.pageCount = 1;
        state.listData = [];
    },
    // 更新请求参数
    [UPDATE_HISTORY_LIST_PARAMS](state, params) {
        const {
            importType, name, mobile, page, carNo,
            importNo, startEndDate
        } = params;
        if (importType || importType === '') state.importType = importType;
        if (name || name === '') state.name = name;
        if (mobile || mobile === '') state.mobile = mobile;
        if (carNo || carNo === '') state.carNo = carNo;
        if (importNo || importNo === '') state.importNo = importNo;
        if (startEndDate) {
            state.startEndDate = startEndDate;
        }

        if (page) {
            state.page = page;
            state.reqParams.page = page; // 分页要进行请求
        }
    },
    [RESET_HISTORY_LIST](state) {
        _.extend(state, _.cloneDeep({
            importType: 1,
            loading: false,
            page: 1,
            pagesize: 20,
            name: '',
            mobile: '',
            carNo: '',
            importNo: '',
            startEndDate: [],
            listData: [],
            pageCount: 1,
            reqParams: {}
        }));
    },
    [RESOLVE_HISTORY_LIST_PARAMS](state, reqParams) {
        state.reqParams = reqParams;
    },
};

export const actions = {
    async getHistoryList({ commit }) {
        commit(GET_HISTORY_LIST_REQUEST);
        const res = await Vue.$ajax.get('historyList', state.reqParams);
        if (!res.errorType) {
            commit(GET_HISTORY_LIST_SUCCESS, res);
        } else {
            commit(GET_HISTORY_LIST_FAILURE);
        }
    },
    resolveHistotyListParams({ commit }) {
        let params = _.pick(state, ['importType', 'name', 'mobile', 'state',
            'page', 'pagesize', 'carNo', 'importNo']);

        params = Object.assign({}, params, {
            startDate: state.startEndDate.length ? state.startEndDate[0] : null,
            endDate: state.startEndDate.length ? state.startEndDate[1] : null
        });
        commit(RESOLVE_HISTORY_LIST_PARAMS, params);
    },

    resetTab({ commit }, importType) {
        const params = Object.assign({}, {
            importType,
            name:'',
            mobile:'',
            page:1,
            pagesize: 20,
            carNo:'',
            importNo:'',
            startDate: null,
            endDate: null
        });
        commit(RESOLVE_HISTORY_LIST_PARAMS, params);
    },

    resetHistoryList({ commit }) {
        commit(RESET_HISTORY_LIST);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/historyList.js